__webpack_require__.p = "https://drop-in-gaming.github.io/node-core/";